<template>
  <div class="content">
    <h2>Вступительные испытания, проводимые ТУСУР самостоятельно</h2>

    <template v-if="!readonly">
      <div class="card card--info" >
        <img class="card__icon icon icon--primary" src="~images/info.svg" v-svg-inline/>
        <p>
          Для сдачи дистанционных вступительных испытаний и просмотра результатов перейдите по
          <router-link :to="{ name: 'abiturient.index', params: { tab: 'exams' } }">ссылке</router-link>
        </p>
      </div>

      <hr>
    </template>

    <div class="card card--info">
      <img class="card__icon icon icon--primary" src="~images/info.svg" v-svg-inline/>
      <p>
        Для записи на вступительные испытания обратитесь в
        <strong>Отдел аспирантуры и докторантуры</strong>:
      </p>
    </div>

    <section class="application-contacts">
      <div class="application-contacts__grid application-contacts__grid--single">
        <article class="application-contacts__card">
          <h4 class="application-contacts__title">Заведующий аспирантурой</h4>
          <p class="application-contacts__name">Коротина Татьяна Юрьевна</p>

          <address class="application-contacts__items">
            <p class="application-contacts__item">
              <img src="~/images/address.svg" class="icon icon--primary icon--sm" v-svg-inline>
              <span>Томская область Томск пр-т Ленина 40 гк, 205</span>
            </p>
            <a class="application-contacts__item" href="tel:+73822900100">
              <img src="~/images/phone.svg" class="icon icon--primary icon--sm" v-svg-inline>
              <span>+7 (3822) 701-523</span>
            </a>
            <a class="application-contacts__item" href="mailto:postupi@tusur.ru">
              <img src="~/images/email.svg" class="icon icon--primary icon--sm" v-svg-inline>
              <span>korotina@tusur.ru</span>
            </a>
          </address>
        </article>

        <article class="application-contacts__card">
          <h4 class="application-contacts__title">Специалист по учебно-методической работе</h4>
          <p class="application-contacts__name">Боберь Юлия Николаевна</p>

          <address class="application-contacts__items">
            <p class="application-contacts__item">
              <img src="~/images/address.svg" class="icon icon--primary icon--sm" v-svg-inline>
              <span>Томская область Томск пр-т Ленина 40 гк, 205</span>
            </p>
            <a class="application-contacts__item" href="tel:+73822900100">
              <img src="~/images/phone.svg" class="icon icon--primary icon--sm" v-svg-inline>
              <span>+7 (3822) 701-558</span>
            </a>
            <a class="application-contacts__item" href="mailto:postupi@tusur.ru">
              <img src="~/images/email.svg" class="icon icon--primary icon--sm" v-svg-inline>
              <span>u.bober@main.tusur.ru</span>
            </a>
          </address>
        </article>
      </div>
    </section>

    <hr>

    <div class="join join--col">
      <h5>Перечень вступительных испытаний:</h5>
      <ol>
        <li>Специальный предмет, соответствующий научной специальности</li>
        <li>Иностранный язык (по выбору)</li>
      </ol>
    </div>
  </div>
</template>

<script setup>
defineProps({
  readonly: { type: Boolean, default: false },
})
</script>